import service from '@/plugins/service'

const crmApi = {}

crmApi.crmreport = (report, company, startDatetime, endDatetime) => {
  return service({
    url: '/customer_profile/report/get/list',
    method: 'get',
    params: {
      reporter: report,
      company: company,
      startDatetime: startDatetime,
      endDatetime: endDatetime
    }
  })
}

crmApi.checkreport = (reportid, customerFullName) => {
  return service({
    url: '/customer_profile/report/check',
    method: 'get',
    params: {
      id: reportid,
      customerFullName: customerFullName
    }
  })
}

crmApi.datainsert = (insertData) => {
  return service({
    url: '/customer_profile/report/insert',
    method: 'post',
    data: insertData
  })
}

crmApi.arealist = () => {
  return service({
    url: '/customer_profile/area/list',
    method: 'get'
  })
}

crmApi.industrylist = () => {
  return service({
    url: '/customer_profile/industry/list',
    method: 'get'
  })
}

crmApi.salesmanupdata = (currentData, salesman, updatedAt) => {
  return service({
    url: `/customer_profile/report/update/${currentData.id}`,
    method: 'post',
    data: {
      reporter: currentData.reporter,
      dept: currentData.dept,
      salesman: salesman,
      areaId: currentData.areaId,
      customerFullName: currentData.customerFullName,
      address: currentData.address,
      industry: currentData.industry,
      contactPerson: currentData.contactPerson,
      mobile: currentData.mobile,
      professionalTitle: currentData.professionalTitle,
      brand: currentData.brand,
      infoNote: currentData.infoNote,
      competitor: currentData.competitor,
      hard: currentData.hard,
      remark: currentData.remark,
      createdAt: currentData.createdAt,
      updatedAt: updatedAt
    }
  })
}

crmApi.salesdeptList = (name) => {
  return service({
    url: `/customer_profile/report/salesdeptlist/${name}`,
    method: 'get'
  })
}

crmApi.searchCompany = (company) => {
  return service({
    url: '/customer_profile/report/searchCompany',
    method: 'get',
    params: {
      company: company
    }
  })
}

crmApi.getMaintainList = (page, size, params, flag) => {
  return service({
    url: `/customer_profile/maintain/list/${flag}/${page}/${size}`,
    method: 'get',
    params
  })
}

crmApi.exportMaintainList = (params, flag) => {
  return service({
    url: `/customer_profile/maintain/list/export/${flag}`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export default crmApi
